<template>
  <div>
    <form @submit.prevent="submitQuery">
      <div>
        <textarea
          type="text"
          class="inputarea card-animate-2"
          placeholder="Describe your query here"
          v-model="queryPrompt"
          rows="4"
          cols="500"
          @keyup.enter="submitQuery"
        ></textarea>
      </div>

      <br />
      <v-icon :color="recordingStateColor">mdi-microphone</v-icon>
      <div>
        <v-btn class="mx-2" type="submit" value="Submit">Submit</v-btn>
        <v-btn class="mx-2" type="submit" value="Reset" @click="resetDialogue">Reset</v-btn>
        <v-btn class="mx-2" @click="promptUserAndStartRecording">Start Developer Mode</v-btn>
      </div>
    </form>

    <div id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry"></p>
    </div>
    <br />
    <div v-if="loading" class="loading-container">
  <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
  <br />
  <p>{{ loadingText }}</p>
  <!-- <div v-if="generatedCode" class="typewriter">
    <p>{{ generatedCode }}</p>
  </div> -->
</div>

    <div id="codeEditor"></div>
    <iframe id="outputIframe" sandbox="allow-scripts allow-same-origin"></iframe>

    <div>
      <v-btn class="mx-2" @click="copyCode">Copy Code</v-btn>
      <v-btn class="mx-2" @click="shareCode">Share Code</v-btn>
      <v-btn class="mx-2" @click="saveCode">Save Code</v-btn>
      <v-btn class="mx-2" v-if="editingCodeIndex !== -1" @click="updateSavedCode">Update Saved Code</v-btn>
    </div>
    <br />
    <saved-code-list
      :saved-code="savedCode"
      @edit-code="editSavedCode"
      @delete-code="deleteSavedCode"
    ></saved-code-list>
  <br />
  </div>
</template>

<script>
import thinkingAudio from '../assets/audio/Smart_UI.wav';
import submitAudio from '../assets/audio/input1.wav';
import typingAudio from '../assets/audio/TypingFuture.wav';
import completeAudio from '../assets/audio/Complete.wav';
import codeCompleteAudio from "../assets/audio/SelectNew.wav";
import SavedCodeList from "./SavedCodeList.vue";
import ace from "brace";
import "brace/mode/html";
import "brace/theme/monokai";
       
export default {
  components: {
    SavedCodeList,
  },
  data() {
    return {
      generatedCode: "",
      loading: false,
      loadingText: "",
      editingCodeIndex: -1,
      queryPrompt: "",
      codeEditor: null,
      dialogueHistory: [],
      savedCode: [],
      isRecording: false,
      recordingStateColor: 'green', // Default color
    };
  },
  mounted() {
     // Trigger the prompt and start recording after the component is mounted
     setTimeout(() => {
      this.promptUserAndStartRecording();
    }, 3000); // 3 seconds after page load
    this.codeEditor = ace.edit("codeEditor");
    this.codeEditor.setTheme("ace/theme/monokai");
    this.codeEditor.session.setMode("ace/mode/html");
    const storedSavedCode = JSON.parse(localStorage.getItem("savedCode"));
    if (storedSavedCode) {
      this.savedCode = storedSavedCode;
    }

    // Add the event listener for changes in the codeEditor
    this.codeEditor.on("change", () => {
      const code = this.codeEditor.getValue();
      document.getElementById("outputIframe").srcdoc = code;
    });
  },
  watch: {
    dialogueHistory() {
      const code = this.dialogueHistory
        .map(entry => entry.text.replace(/<\/?[^>]+(>|$)/g, ""))
        .join("\n");
      this.codeEditor.setValue(code, 1);
      document.getElementById("outputIframe").srcdoc = code;
    },
  },
  methods: {
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

    //   speech.onend = function() {
    //   setTimeout(() => {
    //     Event.$emit('speakModeOn');
    //   }, 4000);
    //  };
    },
    // promptUserAndStartRecording() {
    //   if (this.isRecording) {
    //     this.isRecording = false;
    //     this.recordingStateColor = 'green';
    //     this.readOutLoud('Developer mode off. Please review the code and make any necessary changes.');
    //   } else {
    //     this.isRecording = true;
    //     this.recordingStateColor = 'red';
    //     this.readOutLoud('Developer mode on. Please describe your query.');
    //   }
    // },
    promptUserAndStartRecording() {
  this.readOutLoud('What can I help you code?');
  setTimeout(() => {
    this.isRecording = true;
    this.recordingStateColor = 'green';
    this.startRecording();
  }, 2000);
},

startRecording() {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();
  recognition.lang = 'en-US';
  recognition.continuous = true; // Keep the microphone open
  recognition.start();

  let finalTranscript = ''; // To store the final transcript
  let lastUpdateTime = Date.now(); // To track the last time the transcript was updated

  recognition.onstart = () => {
    this.recordingStateColor = 'blue'; // Color when user is speaking
  };

  recognition.onresult = (event) => {
    let interimTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        finalTranscript += event.results[i][0].transcript;
      } else {
        interimTranscript += event.results[i][0].transcript;
      }
    }
    this.queryPrompt = finalTranscript + interimTranscript;
    lastUpdateTime = Date.now();

    // If the user has stopped speaking for 3 seconds, stop recording
    setTimeout(() => {
      if (Date.now() - lastUpdateTime > 3000) {
        recognition.stop();
      }
    }, 3000);
  };

  recognition.onend = () => {
    this.recordingStateColor = 'red'; // Color just before submitting
    this.isRecording = false;
    this.submitQuery();
  };

  recognition.onerror = (event) => {
    console.error('Speech recognition error', event);
    this.isRecording = false;
  };

  this.isRecording = true;

  // Stop recording automatically after 10 seconds of speech
  setTimeout(() => {
    if (this.isRecording) {
      recognition.stop();
    }
  }, 15000);
},

async submitQuery() {
  if (!this.queryPrompt) return;

  this.displayDialogue(`<strong>User:</strong> ${this.queryPrompt}`);

  // Show loading spinner and "Thinking" text
  window.scrollTo(0, 280);
  new Audio(submitAudio).play();
  this.loading = true;
  this.loadingText = "Submitted...";
  setTimeout(() => {
    new Audio(thinkingAudio).play();
    this.loadingText = "Thinking...";
  }, 1000);
  try {
    const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message: this.queryPrompt }),
    });
    const content = await response.json();

    // Hide loading spinner and "Thinking" text
    this.loadingText = "Generating Code";

    let message = content.message.replace(/AI/g, "").replace(/:/g, "").trim();

    // Show generated code with typewriter animation in loading-container
    this.generatedCode = message;

    // Add a delay before loading codeEditor and playing completion sound
    setTimeout(async () => {
      // Play the completion sound
      new Audio(codeCompleteAudio).play();

      // Update codeEditor and outputIframe
      // this.codeEditor.insert(message);
      // window.scrollTogetElementById("outputIframe"({ left: 0, top: document.body.scrollHeight, behavior: "smooth" }));
      document.getElementById("outputIframe").srcdoc = this.codeEditor.getValue();

      // Reset loading-container
      this.generatedCode = "";
      this.loading = false;
      this.loadingText = "";

      // Animate the text with a fade-in style
      const animateCode = async () => {
        const codeLength = message.length;
        let currentIndex = 0;
        new Audio(typingAudio).play();
        const typeNextChar = () => {
          const currentChar = message.charAt(currentIndex);
          if (currentIndex < codeLength) {
            this.codeEditor.insert(currentChar);
            currentIndex++;
            setTimeout(typeNextChar, 2);
          } else {
            new Audio(completeAudio).play();
            this.readOutLoud('Code generation complete. Please review the code and make any necessary changes.');
          }
        };

        typeNextChar();
      };

      await animateCode();

      const date = new Date().toISOString();
      this.storeConversation(date, this.dialogueHistory);
    }, 2500); // Adjust the delay as needed

    this.queryPrompt = "";

  } catch (err) {
    console.error(err);
  }
},
    storeConversation(date, content) {
      const storedConversations = JSON.parse(localStorage.getItem("conversations")) || [];
      storedConversations.push({ date, content });

      localStorage.setItem("conversations", JSON.stringify(storedConversations));
    },
    displayDialogue(entry) {
      this.dialogueHistory.push(entry);
    },
    resetDialogue() {
      this.dialogueHistory = [];
      this.codeEditor.setValue("", 1);
      document.getElementById("outputIframe").srcdoc = "";
    },
    copyCode() {
      const textarea = document.createElement("textarea");
      textarea.value = this.codeEditor.getValue();
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("Code copied to clipboard!");
    },
    shareCode() {
      const code = encodeURIComponent(this.codeEditor.getValue());
      const shareUrl = `https://api.whatsapp.com/send?text=${code}`;
      window.open(shareUrl, "_blank");
    },
    editSavedCode(index) {
      const code = this.savedCode[index].code;
      this.codeEditor.setValue(code, 1);
      document.getElementById("outputIframe").srcdoc = code;
      this.editingCodeIndex = index;
    },
    updateSavedCode() {
      const updatedCode = this.codeEditor.getValue();
      this.savedCode[this.editingCodeIndex].code = updatedCode;
      localStorage.setItem("savedCode", JSON.stringify(this.savedCode));
      alert("Code updated!");
      this.editingCodeIndex = -1;
    },
    deleteSavedCode(index) {
      this.savedCode.splice(index, 1);
      localStorage.setItem("savedCode", JSON.stringify(this.savedCode));
    },
    saveCode() {
      const code = this.codeEditor.getValue();
      const date = new Date().toISOString();
      this.savedCode.push({ date, code });
      localStorage.setItem("savedCode", JSON.stringify(this.savedCode));
      alert("Code saved!");
    },
    loadSavedCode() {
      const savedCode = JSON.parse(localStorage.getItem("savedCode"));
      if (!savedCode) {
        alert("No saved code found!");
        return;
      }
      this.savedCode = savedCode;
      // Display the saved code in a list, allowing users to edit or delete it
      // You can create a separate component to display and handle the saved code list
    },
  },
};
</script>

<style>
.ace_cursor {
  border-right: 0.15em solid orange;
  animation: blink-caret 0.5s step-end infinite;
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: orange;
  }
}
.ace_line {
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.15em;
  animation: typing 0.0001s steps(30, end);
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
.inputarea {
  width: 100%;
  height: 100%;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
}

#codeEditor {
    width: 100%;
    height: 400px;
}
  #outputIframe {
    width: 100%;
    height: 400px;
    border: 1px solid #ccc;
  }
  
  #dialogueResults {
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  #savedProjects {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  max-height: 200px;
  overflow-y: auto;
}
</style>
